import React from 'react';
import PropTypes from 'prop-types';
import { Formik, Form, Field, FieldArray } from 'formik';
import {
  Button,
  Input,
  Textarea,
  FormControl,
  FormLabel,
  Box,
  HStack,
  VStack,
  Switch,
} from '@chakra-ui/react';
import { FaRegTrashAlt } from 'react-icons/fa';

const PromptOutlineForm = ({ data, updateOutlines, isDisabled }) => {
  // console.log('PromptOutlineForm, data: ', data);
  return (
    <Formik
      enableReinitialize
      initialValues={{
        outlines: data,
      }}
      onSubmit={(values) => {
        // console.log(values);
        updateOutlines(values);
      }}
    >
      {({ values }) => (
        <Form>
          <FieldArray name="outlines">
            {({ remove, push }) => (
              <VStack spacing={4} align="stretch">
                {values?.outlines?.map((outline, index) => (
                  <Box
                    key={index}
                    borderWidth="1px"
                    borderRadius="lg"
                    p={4}
                    w="full"
                  >
                    <HStack spacing={4} align="center" justify="space-between">
                      <FormControl>
                        <HStack spacing={4} align="center">
                          <FormLabel
                            htmlFor={`outlines.${index}.task`}
                            mb={0}
                            fontSize="md"
                            fontWeight="bold"
                            minWidth="64px"
                          >
                            Task {index + 1}
                          </FormLabel>
                          <Field
                            as={Input}
                            id={`outlines.${index}.task`}
                            name={`outlines.${index}.task`}
                            placeholder={`Task ${index + 1}`}
                          />
                        </HStack>
                      </FormControl>
                      {/* Mandatory Switch */}
                      <FormControl display="flex" alignItems="center">
                        <FormLabel
                          htmlFor={`outlines.${index}.mandatory`}
                          mb={0}
                          ml={8}
                        >
                          Mandatory
                        </FormLabel>
                        <Field
                          as={Switch}
                          id={`outlines.${index}.mandatory`}
                          name={`outlines.${index}.mandatory`}
                          colorScheme="teal"
                          isChecked={values.outlines[index].mandatory}
                          type="checkbox"
                        />
                      </FormControl>
                      <Box>
                        <FaRegTrashAlt
                          color="red"
                          onClick={() => remove(index)}
                        />
                      </Box>
                    </HStack>

                    {/* Tips Section */}
                    <FieldArray name={`outlines.${index}.tips`}>
                      {({ remove: removeTip, push: pushTip }) => (
                        <VStack spacing={2} mt={4} ml={8} align="stretch">
                          {outline?.tips?.map((tip, tipIndex) => (
                            <HStack
                              key={`tip-${index}-${tipIndex}`}
                              spacing={4}
                              align="center"
                              justify="space-between"
                            >
                              <FormControl>
                                <HStack spacing={2} align="center">
                                  <FormLabel
                                    htmlFor={`outlines.${index}.tips.${tipIndex}`}
                                    mb={0}
                                    fontSize="sm"
                                    fontWeight="bold"
                                    minWidth="40px"
                                  >
                                    Tip {tipIndex + 1}
                                  </FormLabel>
                                  <Field
                                    as={Textarea}
                                    id={`outlines.${index}.tips.${tipIndex}`}
                                    name={`outlines.${index}.tips.${tipIndex}`}
                                    placeholder={`Tip ${tipIndex + 1}`}
                                  />
                                </HStack>
                              </FormControl>
                              <FaRegTrashAlt
                                color="red"
                                onClick={() => removeTip(tipIndex)}
                              />
                            </HStack>
                          ))}
                          <Button
                            size="sm"
                            colorScheme="teal"
                            onClick={() => pushTip('')}
                            alignSelf="flex-start"
                          >
                            Add Tip
                          </Button>
                        </VStack>
                      )}
                    </FieldArray>
                  </Box>
                ))}

                {/* Add Task Button */}
                <Button
                  size="sm"
                  colorScheme="teal"
                  onClick={() => push({ task: '', tips: [''] })}
                  alignSelf="flex-end"
                >
                  Add Task
                </Button>
              </VStack>
            )}
          </FieldArray>

          {/* Submit Button */}
          <Box textAlign="center" mt={4}>
            <Button
              type="submit"
              isDisabled={isDisabled}
              isLoading={isDisabled}
              colorScheme="green"
              size="md"
              mb={8}
            >
              Update Outlines
            </Button>
          </Box>
        </Form>
      )}
    </Formik>
  );
};

PromptOutlineForm.propTypes = {
  updateOutlines: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  data: PropTypes.arrayOf(
    PropTypes.objectOf(
      PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.bool,
        PropTypes.arrayOf(PropTypes.string),
      ])
    )
  ),
};

export default PromptOutlineForm;
